import { AUTO_RELOAD_COUNT_STORAGE_KEY, AUTO_RELOAD_MAX_PER_SESSION } from "../constants";

const getAutoReloadCount = (): number => {
  const storedCount = Number.parseInt(sessionStorage.getItem(AUTO_RELOAD_COUNT_STORAGE_KEY) ?? "", 10);
  return Number.isNaN(storedCount) ? 0 : storedCount;
};

export const hasReachedAutoReloadLimit = (): boolean => {
  return getAutoReloadCount() >= AUTO_RELOAD_MAX_PER_SESSION;
};

export const recordAutoReload = (): void => {
  sessionStorage.setItem(AUTO_RELOAD_COUNT_STORAGE_KEY, String(getAutoReloadCount() + 1));
};
